import { useEffect, useState } from "react";

// A value derived from the clock, re-derived on an interval rather than frozen
// at mount: a dashboard left open on a kitchen screen runs for days, and both
// the service day and the viewer's offset from it move while it does.
//
// Setting the same value is a no-op in React, so a component only re-renders
// when the derived value actually changes.
//
// `derive` must be stable — it is in the effect's deps, so an inline arrow
// would tear the interval down and rebuild it on every render, and with a
// short enough render loop the timer would never reach `intervalMs` and the
// value would never move. Both callers pass a module-level function.
export default function usePolledValue(derive, intervalMs = 60 * 1000) {
  const [value, setValue] = useState(derive);

  useEffect(() => {
    const timer = setInterval(() => setValue(derive()), intervalMs);
    return () => clearInterval(timer);
  }, [derive, intervalMs]);

  return value;
}
